import React, { useState, useEffect } from 'react'
import { Button, CircularLoader, Modal, Select } from '@st-operations/uikit/src/v2'
const TEAM_ID = require('../../../constants/sharethis_team_id.js')
import { addDatasphereAdmin } from '_services/permissions'
import { logErrorAsync } from '_lib/utility'
import User from '_lib/User'

export const AddDatasphereAdminModal = ({ onClose }) => {
  const [selectedUser, setSelectedUser] = useState('')
  const [users, setUsers] = useState({})
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    setIsLoading(true)

    User.getTeamInfo(TEAM_ID, (err, team) => {
      if (err) {
        toast.error('Error getting your team information')
      } else {
        team.users.sort((a, b) => (a.email > b.email ? 1 : -1))
        setUsers(team.users.map((user) => ({ label: user.email, value: user._id })))
      }
      setIsLoading(false)
    })
  }, [])

  const handleAddAdmin = async (event) => {
    event.preventDefault()

    try {
      await addDatasphereAdmin(selectedUser)
      setSelectedUser('')
      onClose()
      toast('Admin added')
    } catch (error) {
      logErrorAsync(error)
      toast.error(error.message)
    }
  }

  const handleSelectedUserChange = (value, name, option) => {
    setSelectedUser(option)
  }

  return (
    <Modal
      isOpen={true}
      onClose={onClose}
      classes={{
        content: 'w-[500px]',
        childWrapper: 'w-full',
        innerWrapper: 'w-full',
      }}
    >
      <section title="Add DataSphere admin" className="use-preflight">
        <If condition={isLoading}>
          <div className="flex justify-center items-center h-24">
            <CircularLoader className="border-4" />
          </div>
        </If>
        <If condition={!isLoading}>
          <form className="px-4 py-2 border border-gray-300 rounded-lg w-full flex items-center gap-2">
            <Select
              type="text"
              placeholder="Enter user email"
              className="w-full grow m-0"
              onChange={handleSelectedUserChange}
              value={selectedUser}
              options={users}
              menuPortalTarget={document.body}
              styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              useReactSelect
            />
            <Button type="submit" className="whitespace-nowrap m-0" onClick={handleAddAdmin}>
              Add admin
            </Button>
          </form>
        </If>
      </section>
    </Modal>
  )
}
